<ion-content appIonScrollbar [scrollbarWidth]="0">
  <ng-container *ngIf="isModal">
    <ion-button
      (click)="closeModal()"
      fill="clear"
      color="light"
      class="close-button ion-no-padding"
    >
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>
  </ng-container>

  <ion-header *ngIf="!isModal && dataServ.rData.hotel_type === 'Free'">
    <ion-toolbar>
      <ion-back-button
        [color]="'white'"
        slot="start"
        defaultHref="/home"
        text=""
        icon="chevron-back"
      ></ion-back-button>
    </ion-toolbar>
  </ion-header>

  <ion-grid class="content-grid {{ authServ.isLogged }}">
    <ion-row class="top-row">
      <img
        [src]="dataServ.rData.slider_images[0]"
        *ngIf="
          dataServ.rData &&
          dataServ.rData.slider_images &&
          dataServ.rData.slider_images.length > 0
        "
        [ngStyle]="{ 'object-position': didInit ? 'center' : 'bottom' }"
        class="bg"
      />
      <div class="overlay"></div>

      <ion-col size="9" offset="1.5">
        <br />
        <img
          class="logo"
          [src]="dataServ.rData.light_logo[0] || dataServ.rData.dark_logo[0]"
          *ngIf="dataServ.rData.light_logo[0] || dataServ.rData.dark_logo[0]"
        />
      </ion-col>

      <ion-col size="12">
        <br />
        <img src="assets/svg/profile.svg" class="icon" />
      </ion-col>
      <ion-col size="12">
        <ion-text color="light" class="ion-text-center">
          <h1>{{ "My Profile" | translate }}</h1>
          <ion-text color="light">
            <h3 *ngIf="authServ.isLogged && authServ.profile">
              {{ "Welcome back" | translate }},
              <b>{{ authServ.profile.first_name }}</b>
            </h3>
          </ion-text>

          <ion-text color="light"> </ion-text>
        </ion-text>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!authServ.isLogged">
      <ng-container *ngIf="!forgetPassword">
        <ion-col size="12" *ngIf="registerForm && !loginDisplay">
          <form [formGroup]="registerForm">
            <ion-grid>
              <ion-row>
                <ion-col
                  size="12"
                  *ngIf="
                    !regAuthType || regAuthType === 'password_authentication'
                  "
                >
                  <ion-text
                    color="white"
                    (click)="loginDisplay = true"
                    class="ion-text-center"
                  >
                    <h5 class="text-underline">
                      {{
                        "Do you have an account? Please login here." | translate
                      }}
                    </h5>
                  </ion-text>
                </ion-col>

                <!-- New Login Standart Area Starts -->
                <ng-container
                  *ngFor="
                    let loginField of this.dataServ.rData
                      .register_by_module_page_field_setup
                  "
                >
                  <ng-container [ngSwitch]="loginField.control_part_value">
                    <ng-container *ngSwitchCase="'date_of_birth'">
                      <ion-col size="{{ loginField.width === 1 ? '12' : '6' }}">
                        <ion-item>
                          <ion-label position="stacked"
                            >{{ "Birth Date" | translate }}
                            <ion-text *ngIf="loginField.required" color="danger"
                              >*</ion-text
                            >
                          </ion-label>
                          <ion-datetime
                            formControlName="{{
                              loginField.control_part_value
                            }}"
                            required="{{ loginField.required }}"
                            display-format="DD.MM.YYYY"
                          ></ion-datetime>
                        </ion-item>
                      </ion-col>
                    </ng-container>

                    <ng-container *ngSwitchCase="'checkin_date'">
                      <ion-col size="{{ loginField.width === 1 ? '12' : '6' }}">
                        <ion-item>
                          <ion-label position="stacked"
                            >{{ "Check-in" | translate }}
                            <ion-text *ngIf="loginField.required" color="danger"
                              >*</ion-text
                            >
                          </ion-label>
                          <ion-datetime
                            formControlName="{{
                              loginField.control_part_value
                            }}"
                            [max]="maxDate"
                            [min]="minDate"
                            required="{{ loginField.required }}"
                            display-format="DD.MM.YYYY"
                          ></ion-datetime>
                        </ion-item>
                      </ion-col>
                    </ng-container>

                    <ng-container *ngSwitchCase="'check_out_date'">
                      <ion-col size="{{ loginField.width === 1 ? '12' : '6' }}">
                        <ion-item>
                          <ion-label position="stacked"
                            >{{ "Check-out" | translate }}
                            <ion-text *ngIf="loginField.required" color="danger"
                              >*</ion-text
                            >
                          </ion-label>
                          <ion-datetime
                            formControlName="{{
                              loginField.control_part_value
                            }}"
                            [max]="maxDate"
                            [min]="minDate"
                            required="{{ loginField.required }}"
                            display-format="DD.MM.YYYY"
                          ></ion-datetime>
                        </ion-item>
                      </ion-col>
                    </ng-container>

                    <ng-container *ngSwitchCase="'password'">
                      <ion-col size="{{ loginField.width === 1 ? '12' : '6' }}">
                        <ion-item>
                          <ion-label position="stacked"
                            >{{ "Password" | translate }}
                            <ion-text *ngIf="loginField.required" color="danger"
                              >*</ion-text
                            >
                          </ion-label>
                          <ion-input
                            #passwordInput
                            required="{{ loginField.required }}"
                            formControlName="{{
                              loginField.control_part_value
                            }}"
                            type="password"
                          ></ion-input>
                          <ion-icon
                            slot="end"
                            (click)="
                              passwordInput.type === 'password'
                                ? (passwordInput.type = 'text')
                                : (passwordInput.type = 'password')
                            "
                            [name]="
                              passwordInput.type === 'password'
                                ? 'eye-outline'
                                : 'eye-off-outline'
                            "
                          ></ion-icon>
                        </ion-item>
                      </ion-col>
                    </ng-container>

                    <ng-container *ngSwitchCase="'privacy_policy'">
                      <ion-col size="12">
                        <ion-item class="no-border">
                          <input
                            class="custom-checkbox"
                            type="checkbox"
                            #privacyCheck
                            name=""
                            formControlName="{{
                              loginField.control_part_value
                            }}"
                          />
                          <ion-label class="policy" text-wrap>
                            <span
                              class="policy"
                              [innerHTML]="
                                loginField.control_part_value_ml | caption
                              "
                            ></span>
                          </ion-label>
                        </ion-item>
                      </ion-col>
                    </ng-container>

                    <ng-container *ngSwitchCase="'terms_and_conditions'">
                      <ion-col size="12">
                        <ion-item class="no-border">
                          <input
                            class="custom-checkbox"
                            type="checkbox"
                            #termsCheck
                            name=""
                            formControlName="{{
                              loginField.control_part_value
                            }}"
                          />
                          <ion-label text-wrap>
                            <span
                              class="policy"
                              [innerHTML]="
                                loginField.control_part_value_ml | caption
                              "
                            ></span>
                          </ion-label>
                        </ion-item>
                      </ion-col>
                    </ng-container>

                    <ng-container *ngSwitchCase="'passport_no'">
                      <ion-col size="{{ loginField.width === 1 ? '12' : '6' }}">
                        <ion-item>
                          <ion-label position="stacked"
                            >{{ "Identity No / Passport No" | translate }}
                            <ion-text *ngIf="loginField.required" color="danger"
                              >*</ion-text
                            >
                          </ion-label>
                          <ion-input
                            required="{{ loginField.required }}"
                            formControlName="{{
                              loginField.control_part_value
                            }}"
                          ></ion-input>
                        </ion-item>
                      </ion-col>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <ion-col size="{{ loginField.width === 1 ? '12' : '6' }}">
                        <ion-item>
                          <ion-label position="stacked"
                            >{{
                              getLoginFieldName(loginField.control_part_value)
                                | translate
                            }}
                            <ion-text *ngIf="loginField.required" color="danger"
                              >*</ion-text
                            >
                          </ion-label>
                          <ion-input
                            required="{{ loginField.required }}"
                            formControlName="{{
                              loginField.control_part_value
                            }}"
                          ></ion-input>
                        </ion-item>
                      </ion-col>
                    </ng-container>
                  </ng-container>
                </ng-container>

                <ion-col
                  size="12"
                  *ngIf="
                    !regAuthType || regAuthType === 'password_authentication'
                  "
                >
                  <ion-button
                    (click)="register()"
                    [disabled]="registerForm.invalid || processing"
                    expand="block"
                    [color]="
                      registerForm.invalid || processing ? 'white' : 'primary'
                    "
                  >
                    <ion-spinner
                      name="lines"
                      *ngIf="processing"
                      slot="start"
                    ></ion-spinner>
                    <ion-text
                      [color]="
                        registerForm.invalid || processing ? 'medium' : 'white'
                      "
                    >
                      {{ "Register" | translate }}
                    </ion-text>
                  </ion-button>
                </ion-col>

                <ion-col
                  size="12"
                  *ngIf="
                    regAuthType && regAuthType === 'guest_list_authentication'
                  "
                >
                  <ion-button
                    (click)="register()"
                    [disabled]="registerForm.invalid || processing"
                    expand="block"
                    [color]="
                      registerForm.invalid || processing ? 'white' : 'primary'
                    "
                  >
                    <ion-spinner
                      name="lines"
                      *ngIf="processing"
                      slot="start"
                    ></ion-spinner>
                    <ion-text
                      [color]="
                        registerForm.invalid || processing ? 'medium' : 'white'
                      "
                    >
                      {{ "Login" | translate }}
                    </ion-text>
                  </ion-button>
                </ion-col>
                <!-- New Login Standart Area Ends -->
              </ion-row>
            </ion-grid>
          </form>
        </ion-col>

        <ion-col size="12" *ngIf="loginDisplay">
          <form [formGroup]="loginForm">
            <ion-grid>
              <ion-row>
                <!-- ALTINYUNUS -->
                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked"
                      >{{ "Email" | translate }} / {{ "Phone No" | translate }}
                      <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-input formControlName="username"></ion-input>
                  </ion-item>
                </ion-col>
                <!-- ALTINYUNUS -->

                <!-- <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked">{{'Email' | translate}} / {{'Phone No' | translate}} <ion-text
                        color="danger">*</ion-text>
                    </ion-label>
                    <ion-input formControlName="username"></ion-input>
                  </ion-item>
                </ion-col> -->

                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked"
                      >{{ "Password" | translate }}
                      <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-input
                      #passwordInputLogin
                      formControlName="password"
                      type="password"
                    ></ion-input>
                    <ion-icon
                      slot="end"
                      (click)="
                        passwordInputLogin.type === 'password'
                          ? (passwordInputLogin.type = 'text')
                          : (passwordInputLogin.type = 'password')
                      "
                      [name]="
                        passwordInputLogin.type === 'password'
                          ? 'eye-outline'
                          : 'eye-off-outline'
                      "
                    ></ion-icon>
                  </ion-item>
                </ion-col>
                <ion-col size="12">
                  <ion-text
                    color="white"
                    (click)="forgetPassword = true"
                    class="ion-float-right"
                  >
                    <small
                      ><u>{{ "Forgot password?" | translate }}</u></small
                    >
                  </ion-text>
                </ion-col>

                <ion-col size="12">
                  <ion-button
                    (click)="login()"
                    [disabled]="loginForm.invalid || processing"
                    expand="block"
                    [color]="
                      loginForm.invalid || processing ? 'white' : 'primary'
                    "
                  >
                    <ion-spinner
                      name="lines"
                      *ngIf="processing"
                      slot="start"
                    ></ion-spinner>
                    <ion-text
                      [color]="
                        loginForm.invalid || processing ? 'medium' : 'white'
                      "
                    >
                      {{ "Login" | translate }}
                    </ion-text>
                  </ion-button>
                </ion-col>

                <ion-col
                  size="12"
                  *ngIf="
                    !regAuthType || regAuthType === 'password_authentication'
                  "
                >
                  <ion-button
                    (click)="loginDisplay = false"
                    expand="block"
                    fill="clear"
                    color="white"
                  >
                    {{ "Register" | translate }}
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </form>
        </ion-col>
      </ng-container>

      <ng-container *ngIf="forgetPassword">
        <ion-col size="12">
          <form>
            <ion-grid>
              <ion-row>
                <ion-col size="12">
                  <ion-item>
                    <ion-label position="stacked"
                      >{{ "Email" | translate }}
                      <ion-text color="danger">*</ion-text>
                    </ion-label>
                    <ion-input #emailInput type="email"></ion-input>
                  </ion-item>
                </ion-col>

                <ion-col size="12">
                  <ion-button
                    (click)="sendPassword(emailInput.value.toString())"
                    [disabled]="processing"
                    expand="block"
                    [color]="processing ? 'white' : 'primary'"
                  >
                    <ion-spinner
                      name="lines"
                      *ngIf="processing"
                      slot="start"
                    ></ion-spinner>
                    <ion-text [color]="processing ? 'medium' : 'white'">
                      {{ "Send" | translate }}
                    </ion-text>
                  </ion-button>
                </ion-col>

                <ion-col size="12">
                  <ion-button
                    (click)="loginDisplay = true; forgetPassword = false"
                    expand="block"
                    fill="clear"
                    color="white"
                  >
                    {{ "Login" | translate }}
                  </ion-button>
                </ion-col>
              </ion-row>
            </ion-grid>
          </form>
        </ion-col>
      </ng-container>
    </ion-row>

    <ion-row *ngIf="authServ.isLogged" style="height: 100%">
      <ion-col size="12"></ion-col>
    </ion-row>

    <ng-container *ngIf="authServ.isLogged">
      <ion-row class="menu">
        <ion-col size="12">
          <ion-item
            detail="false"
            button="true"
            (click)="modalServ.myProfile('account')"
          >
            <ion-icon slot="start" name="person-outline"></ion-icon>
            <ion-label text-wrap>
              <ion-text color="white">
                <h2>{{ "My Profile" | translate }}</h2>
                <ion-text color="medium">
                  <span>
                    {{ "Password" | translate }},
                    {{ "Contact Information" | translate }}
                  </span>
                </ion-text>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-col>

        <ion-col size="12" *ngIf="!hidePreferences">
          <ion-item
            detail="false"
            button="true"
            (click)="modalServ.myProfile('preferences')"
          >
            <ion-icon slot="start" name="create-outline"></ion-icon>
            <ion-label text-wrap>
              <ion-text color="white">
                <h2>{{ "My Preferences" | translate }}</h2>
                <ion-text color="medium">
                  <span
                    >{{ "Room Options" | translate }},
                    {{ "Favourite Activites" | translate }}</span
                  >
                </ion-text>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-col>

        <ion-col
          size="12"
          *ngIf="
            dataServ.rData.show_chat && dataServ.rData.hotel_type !== 'Free'
          "
        >
          <ion-item
            detail="false"
            button="true"
            (click)="modalServ.openChat(null, true)"
          >
            <ion-icon slot="start" name="headset-outline"></ion-icon>
            <ion-label text-wrap>
              <ion-text color="white">
                <h2>{{ (liveSupportName  | translate ) | caption }}</h2>
                <ion-text color="medium">
                  <span
                    >{{ "FAQ" | translate }}, {{ "Contact Us" | translate }},
                    {{ "Suggestions" | translate }}</span
                  >
                </ion-text>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-col>

        <ion-col size="12">
          <ion-item detail="false" button="true" (click)="logout()">
            <ion-icon slot="start" name="log-out-outline"></ion-icon>
            <ion-label text-wrap>
              <ion-text color="white">
                <h2>{{ "Logout" | translate }}</h2>
              </ion-text>
            </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>
    </ng-container>
  </ion-grid>

  <ion-grid class="second-grid" *ngIf="authServ.isLogged && authServ.profile">
    <ion-row>
      <ng-container *ngIf="dataServ.rData.hotel_type !== 'Free'">
        <ng-container *ngIf="authServ.profile.loyalty_card_no">
          <ion-col size="12" class="membership">
            <ion-text color="light" class="ion-text-center">
              {{ "Membership" | translate }} <br />
              <b>{{ authServ.profile.loyalty_card_family_name }}</b
              ><br />

              <b> #{{ authServ.profile.id }}</b>
              <br /><br />

              <div class="qr-code-frame">
                <qrcode
                  [qrdata]="authServ.profile.loyalty_card_no"
                  [width]="267"
                  [errorCorrectionLevel]="'M'"
                ></qrcode>
                <b> {{ authServ.profile.loyalty_card_no }}</b>
              </div>
            </ion-text>
          </ion-col>

          <ng-container *ngIf="authServ.profile.loyalty_info.points_earned">
            <ion-col size="12" class="third">
              <ion-grid>
                <ion-row>
                  <ion-col size="4">
                    <ion-text color="dark" class="ion-text-center">
                      {{ "POINTS EARNED" | translate }}
                    </ion-text>
                  </ion-col>
                  <ion-col size="4">
                    <ion-text color="dark" class="ion-text-center">
                      {{ "POINTS SPEND" | translate }}
                    </ion-text>
                  </ion-col>
                  <ion-col size="4">
                    <ion-text color="dark" class="ion-text-center">
                      {{ "REMAINING POINT" | translate }}
                    </ion-text>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>

            <ion-col size="12" class="numbers">
              <ion-grid>
                <ion-row>
                  <ion-col size="4">
                    <ion-text color="primary" class="ion-text-center">
                      <h1>{{ authServ.profile.loyalty_info.points_earned }}</h1>
                    </ion-text>
                  </ion-col>
                  <ion-col size="4">
                    <ion-text color="primary" class="ion-text-center">
                      <h1>{{ authServ.profile.loyalty_info.points_spend }}</h1>
                    </ion-text>
                  </ion-col>
                  <ion-col size="4">
                    <ion-text color="primary" class="ion-text-center">
                      <h1>
                        {{ authServ.profile.loyalty_info.remaining_point }}
                      </h1>
                    </ion-text>
                  </ion-col>

                  <ion-col size="12" class="ion-text-center">
                    <ion-text
                      color="primary"
                      class="ion-text-center d-block"
                      (click)="modalServ.openBonusHistory()"
                    >
                      <u> {{ "Point History" | translate }} </u>
                    </ion-text>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>
          </ng-container>
          <ng-container *ngIf="authServ.profile.loyalty_info.target_night_stay">
            <ion-col size="12" class="third">
              <ion-grid>
                <ion-row>
                  <ion-col size="4">
                    <ion-text color="dark" class="ion-text-center">
                      {{ "OVERNIGHT STAY" | translate }}
                    </ion-text>
                  </ion-col>
                  <ion-col size="4">
                    <ion-text color="dark" class="ion-text-center">
                      {{ "TARGET NIGHT STAY" | translate }}
                    </ion-text>
                  </ion-col>
                  <ion-col size="4">
                    <ion-text color="dark" class="ion-text-center">
                      {{ "EARNED NIGHT STAY" | translate }}
                    </ion-text>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>

            <ion-col size="12" class="numbers">
              <ion-grid>
                <ion-row>
                  <ion-col size="4">
                    <ion-text color="primary" class="ion-text-center">
                      <h1>
                        {{ authServ.profile.loyalty_info.overnight_stay }}
                      </h1>
                    </ion-text>
                  </ion-col>
                  <ion-col size="4">
                    <ion-text color="primary" class="ion-text-center">
                      <h1>
                        {{ authServ.profile.loyalty_info.target_night_stay }}
                      </h1>
                    </ion-text>
                  </ion-col>
                  <ion-col size="4">
                    <ion-text color="primary" class="ion-text-center">
                      <h1>
                        {{ authServ.profile.loyalty_info.earned_night_stay }}
                      </h1>
                    </ion-text>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-col>
          </ng-container>
        </ng-container>

        <ng-container *ngFor="let config of myProfileConfig">
          <ng-container [ngSwitch]="config.code">
            <ng-container *ngSwitchCase="'MyAccommodation'">
              <ion-col size="12" class="accommodations" *ngIf="config.show">
                <ion-card (click)="modalServ.myAccommodations()">
                  <ion-img [src]="dataServ.rData.slider_images[0]"></ion-img>

                  <img src="assets/svg/card.svg" class="svg" />
                  <ion-text color="light">
                    <h1>{{ "My Accommodations" | translate }}</h1>
                  </ion-text>
                </ion-card>
              </ion-col>
            </ng-container>
            <ng-container *ngSwitchCase="'MyCreditCards'">
              <ion-col size="12" class="accommodations" *ngIf="config.show">
                <ion-card (click)="modalServ.myCards()">
                  <ion-img src="assets/img/cards.png"></ion-img>
                  <img src="assets/svg/card.svg" class="svg" />
                  <ion-text color="light">
                    <h1>{{ "My Credit Cards" | translate }}</h1>
                  </ion-text>
                </ion-card>
              </ion-col>
            </ng-container>
            <ng-container *ngSwitchCase="'MyOrders'">
              <ion-col size="12" class="accommodations" *ngIf="config.show">
                <ion-card (click)="modalServ.myOrders()">
                  <ion-img src="assets/img/orders.png"></ion-img>
                  <img src="assets/svg/card.svg" class="svg" />
                  <ion-text color="light">
                    <h1>{{ "My Orders" | translate }}</h1>
                  </ion-text>
                </ion-card>
              </ion-col>
            </ng-container>
            <ng-container *ngSwitchCase="'Notifications'">
              <ion-col size="12" class="accommodations" *ngIf="config.show">
                <ion-card (click)="modalServ.notifications()">
                  <ion-img src="assets/img/notifications.png"></ion-img>
                  <img src="assets/svg/card.svg" class="svg" />
                  <ion-text color="light">
                    <h1>{{ "Notifications" | translate }}</h1>
                  </ion-text>
                </ion-card>
              </ion-col>
            </ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ion-row>
  </ion-grid>
</ion-content>
